import useSWR from 'swr';
import { useMemo } from 'react';
// utils
import { fetcher, endpoints } from 'src/utils/axios';

// ----------------------------------------------------------------------

export function useGetMenuConfig() {
  const URL = endpoints.partners.admin.menuConfig;

  const { data, isLoading, error, isValidating, mutate } = useSWR(URL, fetcher, {
    revalidateOnFocus: false,
    dedupingInterval: 60000,
  });

  const memoizedValue = useMemo(
    () => ({
      menuConfig: data?.data || [],
      menuConfigLoading: isLoading,
      menuConfigError: error,
      menuConfigValidating: isValidating,
      menuConfigEmpty: !isLoading && !data?.data?.length,
      mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}
